import React from 'react';
import {useForm} from "react-hook-form";
import {Require} from "../Require";
import {NavLink, useNavigate} from "react-router-dom";
import {season} from "../../../models/season";
import {scrollTo} from "../../../service/ToolsService";
import {ApiError, ApiService} from "../../../service/ApiService";
import {seasonResultType} from "../../../types/Api/SeasonResultType";

type FormDataType = {
  label: string,
  enabled: boolean,
}

type SeasonFormProps = {
  season?: season,
}

export const SeasonForm = ({season}: SeasonFormProps) => {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setError,
    watch,
    formState: {errors}
  } = useForm<FormDataType>({
    defaultValues: {
      label: season?.label ?? '',
      enabled: season?.enabled ?? false,
    }
  });

  const onSubmit = async (data: FormDataType) => {
    const d = {
      label: data.label,
      enabled: data.enabled ? 1 : 0,
    };

    try {
      const result = season
        ? await ApiService.patch(`/season/${season.seasonId}`, {param: () => d}) as seasonResultType
        : await ApiService.post('/season', {param: () => d}) as seasonResultType;

      navigate(season
        ? `/admin/season/show/${result.seasonId}`
        : `/admin/season/edit/${result.seasonId}`
      );
      scrollTo();
    } catch (e: any) {
      const error: ApiError = e as ApiError;

      error.errors?.forEach((e: {
        field: string,
        message: string
      }) => {
        setError(e.field as "label" | "enabled", {
          type: "manual",
          message: e.message
        })
      });
    }
  }

  return (
    <>
      <form className="p-3" method="post" onSubmit={handleSubmit(onSubmit)}>
        <div className="d-flex">
          <div className="col max-w600px pe-4">
            <div className="form-check form-switch mb-3">
              <input className="form-check-input" type="checkbox" id="form-enabled" {...register('enabled')} />
              <label className="form-check-label" htmlFor="form-enabled">
                {`${watch('enabled') ? 'La saison est active' : 'La saison n\'est pas active'}`}
              </label>
            </div>

            <div className="mb-3">
              <label className="form-label" htmlFor="form-label">Saison <Require/></label>
              <input id="form-label" type="text" className="form-control" placeholder="~" {...register('label', {
                required: 'La saison est obligatoire',
                validate: {
                  minLength: (value) =>
                    (value ?? '').length <= 255 || 'La saison ne doit pas dépasser 255 caractères',
                },
              })} />
              {errors.label && <p className="text-danger">{errors.label.message}</p>}
            </div>
          </div>
        </div>

        <div className="mt-3">
          <button className="btn btn-sm btn-success me-1" type="submit">Enregistrer</button>
          {!season && (
            <NavLink to={`/admin/season`} onClick={scrollTo} className="btn btn-sm btn-info me-1">
              Retour aux saisons
            </NavLink>
          )}
          {season && (
            <NavLink to={`/admin/season/show/${season.seasonId}`} onClick={scrollTo} className="btn btn-sm btn-info me-1">
              Retour
            </NavLink>
          )}
        </div>
      </form>
    </>
  )
}
